import { createGlobalStyle } from 'styled-components';
import { colors, fonts } from 'theme/Variables';

// eslint-disable-next-line import/prefer-default-export
export const GlobalStyle = createGlobalStyle`
    /* @import url('https://fonts.googleapis.com/css2?family=Rozha+One&display=swap'); */

    *, *::after, *::before {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin: 0;
        padding: 0;
        box-sizing: border-box
    }

    html {
        font-size: 62.5%;
        color: ${({ theme }) => theme.palette.primary.main};

    }

    body {
        font-family: ${({ theme }) => theme.typography.fontFamily};
        font-size: 1.6rem !important;
        line-height: 2.4rem;
        margin: 0;
        background-color: ${({ theme }) => theme.palette.background.default};
        overflow: auto !important;
    }

    img {
        max-width: 100%;
        height: auto;
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0;
    }
  //  Helpers classes
  .w-100 {
      width: 100%;
  }
  .d-flex {
      display: flex;
  }
  .flex-wrap {
      flex-wrap: wrap;
  }

  // React input - phone number
  .react-tel-input {
    .special-label {
      background-color: transparent;
      transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
      left: 0;
      font-size: 12px;
      color: ${colors.primary['200']};
      top: 0;
      transform: translateY(-50%);
      font-family: ${fonts.secondary};
    }
    .form-control {
      border: 0;
      border-bottom: 1px solid rgba(0 ,0, 0, 0.4);
      border-radius: 0;
      background-color: transparent;
      width: 100%;
      color: ${colors.secondary['200']};
      padding: 6px 0 7px 58px;
      margin-top: 16px;
      &:focus {
          border: 0;
          border-bottom: 2px solid ${colors.secondary['200']};
          outline: none;
          box-shadow: none;
      }
      &:hover {
      border-width: 2px;
      }
    }
    .country-list {
        min-width: 406px;
        @media (max-width: 959px) {
            width: calc(100vw - 60px);
        }
        @media (max-width: 599px) {
            min-width: unset;
            width: calc(100vw - 40px);
        }

    }
  }
  .wrapper-typeform {
        div {
            div {
                overflow: auto !important;
            }
        }
        .widget__IframeWrapper-sc-1rxjz1n-2, .cKLpKc {
            overflow: auto !important;
        }
    }
`;
